import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getHourSlots } from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
class AddBoatMasterTimeSlot extends React.Component {
  state = {
    cruise_booking_date: new Date(),
    slot_from: '',
    slot_to: '',
    isData: false,
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  componentDidMount = () => {
    this.getTimeSlot()
  }

  getTimeSlot = async () => {
    this.setState({ isloading: true })
    var cruiseId = this.props.boatId
    await axios
      .get(Constant.getAPI() + `/slots/list-cruise-time-slot/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.boat_timeslot_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addTimeSLot = () => {
    var that = this
    // const today = new Date();
    // var format = moment(today).format('MM/DD/YYYY')
    var dateDMY = moment(this.state.start_date).format('MM/DD/YYYY')
    var dateDMY1 = moment(this.state.end_date).format('MM/DD/YYYY')

    var data = {
      cruise_id: this.props.boatId,
      start_date: dateDMY,
      slot_from: this.state.slot_from,
      slot_to: this.state.slot_to,
      end_date: dateDMY1,
    }

    this.setState({ isData: true })
    axios
      .post(Constant.getAPI() + `/slots/add-cruise-time-slot`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        that.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'TimeSlot Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/boat-timeslot-lists`
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  EditTimeSlot = () => {
    var dataEdit = {
      cruise_id: this.props.boatId,
      cruise_booking_date: this.state.cruise_booking_date,
      slot_from: this.state.slot_from,
      slot_to: this.state.slot_to,
      is_day_of: this.state.is_day_of,
    }
    this.setState({ isData: true })
    axios
      .put(Constant.getAPI() + `/slots/edit-cruise-time-slot`, dataEdit, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'TimeSlot Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/boat-timeslot-lists`
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  onSaveData = () => {
    var that = this
    let num1 = parseInt(that.state.slot_from)
    let num2 = parseInt(that.state.slot_to)
    if (!(num1 < num2)) {
      document.getElementById('slot_from')?.focus()
      that.setState({ isSaving: false })
      Swal.fire({
        title: 'Starting time must be Smaller than the End time',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    if (this.props.boat_timeslot_id) {
      that.EditTimeSlot()
    } else {
      that.addTimeSLot()
    }
  }
  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            {this.props.boat_timeslot_id ? (
              ''
            ) : (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Start Date</label>
                    <div className="col-sm-9">
                      <input
                        type="date"
                        id="start_date"
                        name="start_date"
                        className="form-control"
                        onChange={this.handleChange}
                        value={this.state.start_date}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">End Date</label>
                    <div className="col-sm-9">
                      <input
                        type="date"
                        id="end_date"
                        name="end_date"
                        className="form-control"
                        onChange={this.handleChange}
                        value={this.state.end_date}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Time Slot From</label>
                <div className="col-sm-9">
                  <select
                    name="slot_from"
                    className="form-control"
                    value={this.state.slot_from}
                    onChange={this.handleChange}
                  >
                    <option>Select Start time(HH:MM)</option>
                    {getHourSlots().map(
                      (itm) => itm.value != '24:00:00' && <option value={itm.value}>{itm.label}</option>
                    )}
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Time Slot end</label>
                <div className="col-sm-9">
                  <select
                    name="slot_to"
                    className="form-control"
                    value={this.state.slot_to}
                    onChange={this.handleChange}
                  >
                    <option>Select End time(HH:MM)</option>
                    {getHourSlots().map(
                      (itm) => itm.value != '24:00:00' && <option value={itm.value}>{itm.label}</option>
                    )}
                  </select>
                </div>
              </div>
            </div>
            {this.props.boat_timeslot_id ? (
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Day status</label>
                  <div className="col-sm-9">
                    <select
                      name="is_day_of"
                      className="form-control"
                      value={this.state.is_day_of}
                      onChange={this.handleChange}
                    >
                      <option value="true">Close</option>
                      <option value="false">Open</option>
                    </select>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/boatsmaster/${this.props.boatType}/${this.props.boatId}/boat-timeslot-lists`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn hor-grd btn-grd-inverse offset-1"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddBoatMasterTimeSlot
